import { gql } from "@apollo/client";

export const GET_MAIN_MENU = gql`
  query {
    getMainMenu {
      code
      label
      description
      url_route
      permission_name
    }
  }
`;

export const GET_MENU_ITEMS = gql`
  query GetMenuItems {
  getMenuItems {
    sections {
      code
      label
      description
      url_route
      permission_name
      children {
        code
        label
        description
        url_route
        permission_name
        children {
          code
          description
          label
          permission_name
          url_route
        }
      }
    }
  }
}
`;